import { useTranslation } from 'contexts/translation-context';

import { ConnectionsPanel } from '../../../telemetry/components/ConnectionsPanel';
import { useSupplier } from './supplierContext';

/**
 * A carrier's tracking connections, on the carrier's own page in the backoffice.
 *
 * The same panel the carrier's portal shows, acting for the carrier whose page this is: a connection added
 * here belongs to this carrier, and a vehicle may be linked only to one of its own trucks. That is how the
 * backoffice sets a carrier's tracking up for them — the carrier sends us a company id and a key, and this
 * is where it is entered and the vehicles it reports are matched to the right trucks.
 */
export const SupplierTrackingPage = () => {
  const { supplier } = useSupplier();
  const { i18n } = useTranslation();

  return (
    <ConnectionsPanel
      party={{ carrierId: supplier.id }}
      title={i18n('liveTracking.connections')}
      subtitle={i18n('liveTracking.connectionsSubtitle')}
    />
  );
};
